import SchedulePaymentModal from './SchedulePaymentModal';

export default SchedulePaymentModal;
